import AOS from 'aos';
import $ from 'jquery';
import 'jquery.cookie';
import Alpine from "alpinejs";
import intersect from '@alpinejs/intersect'


import '@/entrypoints/scripts/sections/lazyloading.js';
import '@/entrypoints/scripts/sections/main-product.js'; // ???
import '@/entrypoints/scripts/sections/product-info-v2.js'; // ???
import '@/entrypoints/scripts/sections/mobile-menu.js'; // ???
import '@/entrypoints/scripts/sections/video.js'; // to many
import '@/entrypoints/scripts/sections/sticky-header.js'; // ???
import '@/entrypoints/scripts/sections/scroll-to.js'; // ???
import '@/entrypoints/scripts/sections/transition.js';
import '@/entrypoints/scripts/sections/related-articles.js';
import '@/entrypoints/scripts/sections/accessibility.js';
import '@/entrypoints/scripts/components/benefit-accordion.js';
import '@/entrypoints/scripts/components/product-form-new.js'
import '@/entrypoints/scripts/components/dynamic-bundle.js'
import '@/entrypoints/scripts/components/recommended-merch.js'
import '@/entrypoints/scripts/sections/accounts.js'
import '@/entrypoints/scripts/sections/productSelect.js'
import '@/entrypoints/scripts/sections/productSpotlight.js';
import '@/entrypoints/scripts/sections/accountNav.js';
import '@/entrypoints/scripts/sections/aw-product-gallery.js';
 
window.AOS = AOS;
window.jQuery = $;
window.$ = $;

document.getElementById('cart-icon-bubble')?.addEventListener('click', () => {
    document.body.classList.add('fixed-body', 'chathide');
});

document.querySelectorAll('.close-side-cart').forEach(button => {
    button.addEventListener('click', () => {
        document.body.classList.remove('fixed-body', 'chathide');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        const yotpo = window.yotpo;

        if (typeof yotpo === "undefined") {
            return;
        }

        const refreshWidgets = yotpo.refreshWidgets;
        if (!refreshWidgets) {
            return;
        }

        if (typeof yotpo.refreshWidgets !== "function") {
            return;
        }

        refreshWidgets();
    }, 500);
});


document.addEventListener('DOMContentLoaded',  () => {
    const accordions = document.querySelectorAll('.accordion-faq');
    if (!accordions) {
        return;
    }

    if (!accordions?.length) {
        return;
    }

    accordions.addEventListener('click', (event) => {
        const header = event?.target?.closest('.accordion-header');
        if (!header) {
            return;
        }

        if (!header?.contains(header)) {
            return;
        }

        header.classList.toggle('active');

        const tabs = document.querySelectorAll('.tabswrap.mob');
        if (!tabs) {
            return;
        }

        if (!tabs?.length) {
            return;
        }

        tabs?.forEach(tab => {
            tab?.classList?.add('hidefooternav');
        });
    });
});


// Returning Visitor Data
  document.addEventListener('alpine:init', () => {
    Alpine.store('visitor', {
      STORAGE_KEY: 'animalpak-vd',
      MAX_VISIT_COUNT: 999999,
      data: null,
      isReturningVisitor: false,

      init() {
        const SESSION_KEY = 'animalpak-session-counted';
        const alreadyCounted = sessionStorage.getItem(SESSION_KEY) === 'true';
      
        const now = new Date().toISOString();
        const existing = this.getVisitorData();
      
        if (!alreadyCounted) {
          const updated = {
            fv: existing?.fv || now,
            lv: now,
            vc: Math.min((existing?.vc || 0) + 1, this.MAX_VISIT_COUNT),
          };
      
          this.setVisitorData(updated);
          this.data = updated;
      
          sessionStorage.setItem(SESSION_KEY, 'true');
        } else {
          this.data = existing;
        }
      
        this.isReturningVisitor = (this.data?.vc || 0) >= 2;
      },

      getVisitorData() {
        try {
          const raw = localStorage.getItem(this.STORAGE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          console.error('Failed to read visitor data:', error);
          return null;
        }
      },

      setVisitorData(data) {
        try {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
        } catch (error) {
          console.error('Failed to write visitor data:', error);
        }
      }
    });

    Alpine.store('visitor').init();
});

// Look for Klaviyo cookie

if (window.location.pathname.includes('/products/')) {
  console.log('hasCookie test')

  function hasCookie(name) {
    return document.cookie
      .split('; ')
      .some(cookie => cookie.startsWith(`${name}=`))
  }

  setTimeout(() => {
    const shopifyCustomer = window.Shopify?.customer

    const shopifyAuthenticated = Boolean(
      shopifyCustomer?.id ||
      shopifyCustomer?.email ||
      window.ShopifyAnalytics?.meta?.page?.customerId
    )

    const klaviyoRecognized =
      hasCookie('__kla_id') ||
      (typeof window.klaviyo?.isIdentified === 'function' && window.klaviyo.isIdentified())

    const recognitionType =
      shopifyAuthenticated && klaviyoRecognized ? 'both' :
      shopifyAuthenticated ? 'shopify_only' :
      klaviyoRecognized ? 'klaviyo_only' :
      'anonymous'

    console.log('pdp identity debug', {
      shopifyCustomer,
      customerId: window.ShopifyAnalytics?.meta?.page?.customerId,
      shopifyAuthenticated,
      klaviyoRecognized,
      recognitionType
    })

    window.Shopify?.analytics?.publish?.('pdp_identity_state_detected', {
      shopifyAuthenticated: String(shopifyAuthenticated),
      klaviyoRecognized: String(klaviyoRecognized),
      recognitionType
    })
  }, 1500)
}
 
import bundleBuilder from "./sections/bundle-builder.js";
import addToCart from "./components/add-to-cart.js";
import blogFilter from "./sections/blog-filters.js";
import productStats from "./sections/productStats.js";
import transition from "./sections/transition.js";
import benefitAccordion from "./components/benefit-accordion.js";
import productFormNew from "./components/product-form-new.js";
import parallax from "./components/parallax.js";
import quantityInputNew from "./components/quantity-input-new.js";
import dynamicBundle from "./components/dynamic-bundle.js";
import recommendedMerch from "./components/recommended-merch.js";
import heroVideo from "./sections/heroVideo.js";
import accounts from "./sections/accounts.js";
import productSelect from "./sections/productSelect.js";
import productSpotlight from "./sections/productSpotlight.js";
import shippingGame from "./components/shippingGame.js";
import accountNav from "./sections/accountNav.js";
import countdown from "./components/countdown.js";
import signupFormVipDrop from "./components/signup-form-vip-drop.js";
import loyaltySlider from "./components/loyalty-slider.js";
import trendingProductsSlider from "./components/trending-products-slider.js";
import loyalty from "./sections/loyalty.js";
import AWProductGallery from "./sections/aw-product-gallery.js";
import certificateModal from "./components/certificate-modal.js";

bundleBuilder(Alpine);
addToCart(Alpine);
blogFilter(Alpine);
productStats(Alpine);
transition(Alpine);
benefitAccordion(Alpine);
productFormNew(Alpine);
parallax(Alpine);
quantityInputNew(Alpine);
dynamicBundle(Alpine);
recommendedMerch(Alpine);
heroVideo(Alpine);
accounts(Alpine);
productSelect(Alpine);
productSpotlight(Alpine);
shippingGame(Alpine);
accountNav(Alpine);
countdown(Alpine);
signupFormVipDrop(Alpine);
loyalty(Alpine);
loyaltySlider(Alpine);
trendingProductsSlider(Alpine);
AWProductGallery(Alpine);
certificateModal(Alpine);

Alpine.plugin(intersect);



window.Alpine = Alpine;
Alpine.start(); 

